import { paths } from "@utils/navigation";
import { NOMINATION_TYPE } from "./nominationTypeOptions";
import type { VesselNominationScanItem } from "./VesselNominationScanResults.types";

export const PRE_NOMINATION_REQUEST_PATH = `/${paths.vesselNomination.index}/${paths.vesselNomination.preNominationRequest}`;
export const DRY_BULK_ADD_PATH = `/${paths.vesselNomination.index}/${paths.vesselNomination.addDryBulk}`;

export interface PostScanTarget {
  path: string;
  state: { vessel: VesselNominationScanItem; nominationType?: string };
}

/** Dry bulk is a single form (no pre-nomination step); liquid keeps its pre-nomination request. */
export const getPostScanTarget = (
  nominationType: string | undefined,
  vessel: VesselNominationScanItem,
): PostScanTarget =>
  nominationType === NOMINATION_TYPE.DRY_BULK
    ? { path: DRY_BULK_ADD_PATH, state: { vessel, nominationType: NOMINATION_TYPE.DRY_BULK } }
    : { path: PRE_NOMINATION_REQUEST_PATH, state: { vessel } };
